// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reqListCreation-root-W8u {\n}\n\n.reqListCreation-firstRow-6Gq {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n.reqListCreation-firstRow-6Gq button {\n    max-width: 120px;\n}\n.reqListCreation-firstRow-6Gq > div:first-of-type {\n    width: 100%;\n    display: flex;\n}\n.reqListCreation-secondRow-sRA {\n    margin-top: 40px;\n}\n.reqListCreation-secondRow-sRA textarea {\n    border: solid 1px #121111;\n}\n\n.reqListCreation-fopActions-aD- {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "reqListCreation-root-W8u w-full mt-12",
	"firstRow": "reqListCreation-firstRow-6Gq px-16",
	"secondRow": "reqListCreation-secondRow-sRA px-16",
	"fopActions": "reqListCreation-fopActions-aD- bg-snowbound mt-20 px-16"
};
export default ___CSS_LOADER_EXPORT___;
